import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";

import SwissMonkey from "../layouts/img/swiss-monkey.svg";
import Logo from "../layouts/img/logo.png";

import Positions from "../layouts/img/positions.svg";
import Notifications from "../layouts/img/notifications.svg";
import Rank from "../layouts/img/rank.svg";
import Media from "../layouts/img/media.svg";
import Profile from "../layouts/img/profile.svg";
import Touch from "../layouts/img/touch.svg";
import RealTime from "../layouts/img/realtime.svg";
import PracticeProfile from "../layouts/img/practice-profile.svg";
import { Modal } from "react-bootstrap";
import Logox2 from "../layouts/img/logox2.png";
import Special from "../layouts/img/199_special.jpg";

import { fetchErrorHelper, fetchResponseHelper } from "../lib/api";

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal2: false,
      showModal3: false,
      showModal: false,
      username: "",
      password: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ showModal: false, showModal2: false, showModal3: false });
  }

  handleShow(modal) {
    this.handleClose();
    this.setState({ [modal]: true });
  }

  handleChange(event, value) {
    this.setState({ [value]: event.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    fetch("https://app.swissmonkey.io/api/v2.0/user/marketing_login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password
      })
    })
      .then(fetchResponseHelper, fetchErrorHelper)
      .then(data => {
        if (data.success) {
          return (window.location.href = data.url);
        }
        return alert(data.message);
      })
      .catch(error => {
        alert(error.message);
      });
  }

  componentDidMount() {
    // if (sessionStorage.getItem('firstVisit') !== "1") {
    //   setTimeout(() => this.handleShow('showModal3'), 1000);
    //   sessionStorage.setItem('firstVisit', '1');
    // }
  }

  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    return (
      <div>
        <div className="hero">
          <div className="container-fluid text-right hidden-xs">
            <a
              href="https://app.swissmonkey.io/users/sign_in"
              className="btn-main btn-sm btn-secondary"
            >
              Sign in
            </a>
          </div>

          <div className="hero-content">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <img src={SwissMonkey} className="hero-monkey" alt="" />
                </div>

                <div className="col-md-8 col-sm-6">
                  <div className="hero-text">
                    <img src={Logo} className="hidden-xs" alt="" />
                    <h1 className="h-72 p-purple weight-light">
                      The Dental Industry’s Coolest Matchmaker.
                    </h1>
                    <div className="mt-50">
                      <p className="p-18 p-gray txt-uppercase weight-bold">
                        Join Free Today!
                      </p>
                    </div>
                    <div className="row d-inline-block">
                      <a
                        href="https://app.swissmonkey.io/users/sign_up"
                        className="btn-main btn-secondary btn-100 thank-you-btn btn-inline-block"
                      >
                        Employer
                      </a>
                      <a
                        href="https://jobs.swissmonkey.io/register"
                        className="btn-main btn-secondary btn-alt btn-100 thank-you-btn btn-inline-block"
                      >
                        Job Seeker
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <main id="main" className="site-main">
          <section className="section-category section-employers text-center">
            <div className="container container-1010">
              <h2 className="h-80">Employers</h2>
              <p className="p-24">Build your dream team.</p>
              <div className="row services">
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={Positions} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      Post perm or temp positions
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img
                        src={Notifications}
                        className="img-responsive"
                        alt=""
                      />
                    </div>
                    <p className="p-24 category-item-text">
                      Immediate notifications
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={Rank} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      Applicants are matched and ranked
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={Media} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      View photos and videos
                    </p>
                  </div>
                </div>
              </div>
              <Link to="/employer" className="purple-link">
                Read More
              </Link>
            </div>
          </section>

          <section className="section-busy">
            <div className="container">
              <div className="card card-busy mx-auto text-center">
                <h2 className="h-60">Too Busy</h2>
                <p className="p-24">
                  Check out our concierge service and let us do the work!
                </p>
                <a href="contact" className="btn-main btn-alt">
                  Contact Us
                </a>
              </div>
            </div>
          </section>

          <section className="section-category section-jobseekers text-center">
            <div className="container container-1010">
              <h2 className="h-80">Job Seekers</h2>
              <p className="p-24">Find permanent and temporary jobs.</p>
              <div className="row services">
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={Profile} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      Create a unique profile
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={Touch} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      One touch job application process
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img src={RealTime} className="img-responsive" alt="" />
                    </div>
                    <p className="p-24 category-item-text">
                      Real time notifications to your Phone
                    </p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="category-item">
                    <div className="category-item-thumb">
                      <img
                        src={PracticeProfile}
                        className="img-responsive"
                        alt=""
                      />
                    </div>
                    <p className="p-24 category-item-text">
                      View practice profiles
                    </p>
                  </div>
                </div>
              </div>
              <Link to="/jobseekers" className="purple-link">
                Read More
              </Link>
            </div>
          </section>

          <section className="section-stay-touch text-center">
            <div className="container container-1010">
              <h2 className="h-80">Stay in Touch</h2>
              <p className="p-24">
                Sign up to get interesting news and updates delivered to your
                inbox.
              </p>
              <form
                id="subscribe-form"
                className="subscribe-form wow fadeIn"
                action="https://visitor2.constantcontact.com/api/signup"
                method="post"
                name="subscribe-form"
                target="popupwindow"
                data-wow-duration="1s"
              >
                <input
                  name="ca"
                  type="hidden"
                  value="43be5a9c-5204-42cd-ba9e-452adc35a317"
                  data-id="ca:input"
                />
                <input
                  name="source"
                  type="hidden"
                  value="EFD"
                  data-id="source:input"
                />
                <input
                  name="required"
                  type="hidden"
                  value="email"
                  data-id="required:input"
                />
                <input
                  id="subscribe-form-email"
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder="email address"
                />

                <div className="radio-btns">
                  <div className="radio-btn">
                    <input
                      type="radio"
                      id="general-interest"
                      name="list_1"
                      value="1595559139"
                    />
                    <label htmlFor="general-interest" className="red">
                      GENERAL INTEREST
                    </label>
                  </div>
                  <div className="radio-btn">
                    <input
                      type="radio"
                      id="employer"
                      name="list_0"
                      value="2035978975"
                    />
                    <label htmlFor="employer" className="red">
                      EMPLOYER
                    </label>
                  </div>
                  <div className="radio-btn">
                    <input
                      type="radio"
                      id="job-seeker"
                      name="list_2"
                      value="1484439458"
                    />
                    <label htmlFor="job-seeker" className="red">
                      JOB SEEKER
                    </label>
                  </div>
                </div>

                <button type="submit" className="btn-main btn-alt">
                  Subscribe
                </button>
              </form>
            </div>
          </section>
        </main>

        {/*<Modal*/}
        {/*show={this.state.showModal3}*/}
        {/*id="special-modal"*/}
        {/*className="special-modal"*/}
        {/*onHide={this.handleClose}*/}
        {/*>*/}
        {/*<Modal.Body>*/}
        {/*<a href="https://app.swissmonkey.io/users/sign_up">*/}
        {/*<img src={Special} className="img-responsive" alt="" />*/}
        {/*</a>*/}
        {/*</Modal.Body>*/}
        {/*</Modal>*/}

        <Modal
          show={this.state.showModal2}
          id="sign-up-modal"
          className="modal-second-level"
          onHide={this.handleClose}
        >
          <Modal.Body>
            <img src={Logox2} className="modal-logo" alt="" />
            {/*<form>*/}
            {/*<div className="input-group input-group-img">*/}
            {/*<img src={EmailGray} alt="" />*/}
            {/*<input*/}
            {/*id="sign-up-email"*/}
            {/*type="text"*/}
            {/*className="form-control form-control-img "*/}
            {/*name="email"*/}
            {/*placeholder="enter valid email"*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<div className="input-group input-group-img">*/}
            {/*<img src={PassGray} alt="" />*/}
            {/*<input*/}
            {/*id="sign-up-password"*/}
            {/*type="text"*/}
            {/*className="form-control form-control-img "*/}
            {/*name="password"*/}
            {/*placeholder="create password"*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<div className="text-center">*/}
            {/*<p className="p-18 p-gray mt-50">or create account using</p>*/}
            {/*</div>*/}

            {/*<ul className="list-unstyled list-inline sign-up-social mt-50">*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Fb} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Google} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*<a href="#">*/}
            {/*<img src={Linked} alt="" />*/}
            {/*</a>*/}
            {/*</li>*/}
            {/*</ul>*/}

            <div className="text-center">
              <p className="p-18 p-gray txt-uppercase weight-bold mt-50">
                REGISTER AS
              </p>
            </div>

            <div className="row mt-50">
              <div className="col-xs-6 col-12">
                <a
                  href="https://app.swissmonkey.io/users/sign_up"
                  className="btn-main btn-secondary btn-100 thank-you-btn"
                >
                  Employer
                </a>
              </div>
              <div className="col-xs-6 col-12 mt-xs-15">
                <a
                  href="https://jobs.swissmonkey.io/register"
                  className="btn-main btn-alt btn-100 thank-you-btn"
                >
                  Job Seeker
                </a>
              </div>
            </div>
            {/*</form>*/}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array
    })
  })
};

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js